export const setBreadCrumb = (
  skipId,
  subpathName,
  type,
  additionalData = {}
) => {
  let newobj = {
    id: skipId,
    name: subpathName,
    type: type,
    additionalData: additionalData,
  };
  let subPathObj = JSON.parse(localStorage.getItem('subpathObj'));
  if (subPathObj && subPathObj.length > 0) {
    let index = subPathObj.findIndex((x) => x.id === newobj.id);
    if (index !== -1) {
      // Preserve existing additionalData if new additionalData is empty
      if (Object.keys(additionalData).length === 0 && subPathObj[index].additionalData) {
        newobj.additionalData = subPathObj[index].additionalData;
      }
      subPathObj[index] = newobj;
    } else {
      subPathObj.push(newobj);
    }
  } else {
    subPathObj = [newobj];
  }
  localStorage.setItem('subpathObj', JSON.stringify(subPathObj));
};
